/* eslint-disable max-len */
import React from 'react';

import MainContainer from '@jobcase/react_pattern_library/components/Container';

import StandardLayout from '../../layouts/standard/StandardLayout';
import withGrants from '../../hoc/withGrants';

const EmployersPage = () => (
  <StandardLayout>
    <MainContainer />
  </StandardLayout>
);

export default withGrants(EmployersPage);
